import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/settings/visitor-menu")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/admin/settings/quick-links",
      params: { orgSlug: params.orgSlug },
    });
  },
});
